import * as React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { Box, Icon, Text, Touchable } from '@factorialco/deprecated-design-system'
import { ExpensablesDataTableQuery } from 'generated/resources/datatable.graphql'

import { observer } from 'mobx-react'

import { useDataTable } from 'modules/core/components/DataTable'
import i18n from 'modules/core/lib/i18n'

import type { Expensable as DataTableExpensable } from 'modules/expenses/components/expenses/DataTable/types'
import { useExpensesNavigation } from 'modules/expenses/hooks/useExpensesNavigation'
import { Expensable } from 'modules/expenses/types/Expensable'

interface NavigationHeaderProps {
  expensable: Expensable
  onRestartApprovalFlow?: () => void
}

const NavigationHeader = ({ expensable }: NavigationHeaderProps) => {
  const navigate = useNavigate()
  const { navigation } = useExpensesNavigation()
  const [searchParams] = useSearchParams()

  const { data } = useDataTable<ExpensablesDataTableQuery, DataTableExpensable>()

  const currentIndex = data.findIndex(({ id }) => id === expensable.id)
  const showPrevious = currentIndex > 0
  const showNext = currentIndex < data.length - 1

  const navigateTo = (expensable?: DataTableExpensable) => {
    if (!expensable) return
    navigate({
      pathname: navigation.helpers.expensableDetail(expensable.id),
      search: searchParams.toString(),
    })
  }

  return (
    <Box flexDirection="row" justifyContent="center" alignItems="center" paddingX="s24" flexGrow>
      {showPrevious && (
        <Touchable
          onClick={() => navigateTo(data[currentIndex - 1])}
          aria-label={i18n.t('expenses_v2.modals.detail.actions.see_previous_expense')}
        >
          <Icon.Small icon="chevron-left" />
        </Touchable>
      )}

      <Box paddingX="s24">
        <Text.Normal weight="semibold">{i18n.t('expenses_v2.navigator.detail_title')}</Text.Normal>
      </Box>

      {showNext && (
        <Touchable
          onClick={() => navigateTo(data[currentIndex + 1])}
          aria-label={i18n.t('expenses_v2.modals.detail.actions.see_next_expense')}
        >
          <Icon.Small icon="chevron-right" />
        </Touchable>
      )}
    </Box>
  )
}

export default observer(NavigationHeader)
